// Lightweight runtime check to detect if the design token custom properties failed to apply
// (e.g., because CSS file was served incorrectly or cached as HTML)
(function(){
  try {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', runCheck);
    } else {
      runCheck();
    }
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn('[StyleGuard] Setup error', e);
  }

  function runCheck(){
    try {
      const root = document.documentElement;
      const brand = getComputedStyle(root).getPropertyValue('--color-brand-primary');
      // Heuristic: if variable missing or suspiciously empty, force one hard reload (once)
      if(!brand || !brand.trim()) {
        if(!sessionStorage.getItem('__style_guard_retry__')){
          sessionStorage.setItem('__style_guard_retry__','1');
          // eslint-disable-next-line no-console
          console.warn('[StyleGuard] Missing token vars; forcing one cache-busting reload');
          // Add a query param to attempt to bypass a stale CDN/html-cached CSS response
          const url = new URL(window.location.href);
            url.searchParams.set('_sg','1');
          setTimeout(()=>{ window.location.replace(url.toString()); }, 40);
        } else {
          // eslint-disable-next-line no-console
            console.warn('[StyleGuard] Second pass still missing tokens. Investigate CDN / Nginx static config.');
        }
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.warn('[StyleGuard] Runtime check failed', e);
    }
  }
})();
